/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_FinalistsInputs */



/**
* | output |
* | --- |
* | "Finalists" |
*
* @param {Og_Cfg_FinalistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_finalists = /** @type {((inputs?: Og_Cfg_FinalistsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_FinalistsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finalistes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalistas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalistas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finalisti")
	return /** @type {LocalizedString} */ ("Finalists")
});